import React from 'react';
import { observer } from 'mobx-react';
import { CenterColumnLayout } from 'components/layouts/center-column-layout';
import { QuickLinks } from 'components/account/quick-links';
import { MediumGap, LargeGap } from '@naan/primitives/spacer/gaps';
// import { SoundbiteEtAlWidgetGroup } from './soundbite-et-al-widget-group';
import { DeepScrollRestoration } from 'lib/scroll-utils/deep-scroll-restoration';
import { useLocation } from 'react-router-dom';
// import { SampleStories } from './sample-stories';
import { FeaturedContent } from './featured-content';
import { UnauthenticatedDashboardNav } from './unauthenticated-dashboard-nav';
import { getMainScrollingContainer } from 'lib/scroll-utils';
import { DashboardFooter } from './dashboard-footer';
import { TeacherWelcomeMessage } from '../welcome-message';
import { AboutRadioAmbulante } from './about-ra';
import { LearnDashboardHeading } from './dashboard-heading';
import { AppFactory } from '@app/app-factory';
import { SectionHeading } from './dashboard-section-heading';
import { Divider } from '@naan/primitives/divider';
import { StoryCard } from 'components/stories/story-card';
import { FreeStoryWidget } from './free-story-widget';
import { LastCompletedWidget } from './completed-widget';
import { ChannelBanner } from './channel-banner';
import { SubscribeCta } from './subscribe-cta';

import __ from '@core/lib/localization';
import { DashboardWidgets } from './dashboard-widgets';

const maybeScrollToFragment = () => {
  const fragment = window.location.hash;
  if (fragment) {
    const element = document.getElementById(fragment.replace('#', ''));

    if (element) {
      const scrollingContainer = getMainScrollingContainer();
      if (scrollingContainer) {
        scrollingContainer.scrollTo({
          top: element.offsetTop - scrollingContainer.offsetTop - 56,
          behavior: 'smooth',
        });
      }
    }
  }
};

const WereYouWereWidget = observer(() => {
  const { storyManager } = AppFactory.root;

  const { featuredInProgress } = storyManager;

  if (!featuredInProgress) {
    return null;
  }

  return (
    <>
      <SectionHeading title={__('Where you were', 'whereYouWere')} />
      <Divider />
      <StoryCard story={featuredInProgress} truncateDescription={true} />
      <LargeGap />
    </>
  );
});

export const TrialDashboard = observer(() => {
  const location = useLocation();
  const { storyManager, userManager, raBranding } = AppFactory.root;

  const { featuredInProgress } = storyManager;
  const featuredCompleted = !featuredInProgress
    ? storyManager.featuredCompleted
    : null;
  const { legacySoundbiteEngagement } = userManager.userData;

  // const raBranding = !storyManager.isMultiChannel;

  React.useEffect(() => {
    requestAnimationFrame(maybeScrollToFragment);
  }, [location]);

  // const freeStory = AppFactory.root.storyManager.storyForUnitSlug('miedo');

  return (
    <>
      <DeepScrollRestoration pageKey={location.pathname} />
      <UnauthenticatedDashboardNav />
      <LearnDashboardHeading />

      <CenterColumnLayout>
        <FreeStoryWidget />
        {/* <TrialWelcomeMessage /> not currently needed */}
        <TeacherWelcomeMessage />
        <WereYouWereWidget />
        {featuredCompleted ? (
          <>
            <LastCompletedWidget story={featuredCompleted} />
            <MediumGap />
          </>
        ) : null}
        {legacySoundbiteEngagement ? (
          <>
            <DashboardWidgets />
            <MediumGap />
          </>
        ) : null}
      </CenterColumnLayout>
      <ChannelBanner />
      <SubscribeCta />
      <CenterColumnLayout backgroundColor="#ffeded">
        <MediumGap />
        <FeaturedContent />
        <LargeGap />
      </CenterColumnLayout>
      {raBranding ? (
        <CenterColumnLayout>
          <MediumGap />
          <AboutRadioAmbulante />
        </CenterColumnLayout>
      ) : null}
      <CenterColumnLayout>
        <MediumGap />
        <QuickLinks />
        <LargeGap />
        <DashboardFooter />
      </CenterColumnLayout>
      {/* <NewsletterDialog /> */}
    </>
  );
});
